import { getEnv } from "../../../utils/env"
import { postRequest } from "../../mp-utils/generic-utils"

// A password is sent only when the import row supplied one; otherwise the
// server generates a passphrase and echoes it back, which is what the login
// letters print.
export const manualAddStudent = async (
  id: string,
  password?: string
): Promise<string> => {
  const url = `${getEnv("CLOUD_FUNCTION_ROOT")}/authGroup-manualAddStudent?`
  const raw = await postRequest(url, { id, ...(password && { password }) })
  // postRequest uses responseType:"text" so raw is a string, but handle
  // both cases defensively in case axios transforms the JSON body.
  const parsed: { password: string } =
    typeof raw === "string" ? JSON.parse(raw) : raw
  if (!parsed?.password) {
    throw new Error("Failed to create student credentials: unexpected server response")
  }
  return parsed.password
}
